import { all, put, takeLatest } from "redux-saga/effects";

import store from "../../store/store";

import { eventEHRCustomToastMessage } from "../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";
import {
  hideLoader,
  showLoader,
} from "../../component-lib/Molecules/loader/LoaderSlice";
import NotificationService from "../../services/NotificationService";
import { componentKey } from "./notificationSlice";

export const { clearAllNotification, patchVerifyOrder, deleteNotification } = {
  clearAllNotification: (payload) => {
    return {
      type: "NOTIFICATION/CLEAR_ALL_NOTIFICATION",
      payload,
    };
  },
  patchVerifyOrder: (payload) => {
    return {
      type: "NOTIFICATION/PATCH_VERIFY_ORDER",
      payload,
    };
  },
  deleteNotification: (payload) => {
    return {
      type: "NOTIFICATION/DELETE_NOTIFICATION",
      payload,
    };
  },
};

// GET ALL NOTIFICATION ASYNC
function* clearAllNotificationAsync(action) {
  const { loginUserId, clearNotifications } = action?.payload;
  try {
    yield put(showLoader());
    const response =
      yield NotificationService.clearAllNotification(loginUserId);

    const { status, message } = response;

    if (status) {
      eventEHRCustomToastMessage({
        title: `Notifications cleared successfully.`,
        status: "success",
      });
      clearNotifications();
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* patchOrderVerifyAsync(action) {
  try {
    yield put(showLoader());
    const response = yield NotificationService.patchVerifyOrderStatus(
      action?.payload?.orderId,
      action?.payload?.payload
    );
    if (response?.status) {
      const message = response?.data?.message;

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET ALL NOTIFICATION ASYNC
function* deleteNotificationAsync(action) {
  try {
    yield put(showLoader());
    const response = yield NotificationService.deleteNotification(
      action?.payload?.id
    );

    if (response?.status) {
      const message = response?.data?.message;

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      // action?.payload?.clearNotifications();
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* rootSaga() {
  yield all([
    takeLatest(clearAllNotification().type, clearAllNotificationAsync),
  ]);
  yield all([takeLatest(patchVerifyOrder().type, patchOrderVerifyAsync)]);
  yield all([takeLatest(deleteNotification().type, deleteNotificationAsync)]);
}

store.sagaManager.addSaga(componentKey, rootSaga);
